// extracted by mini-css-extract-plugin
export default {"container":"_3tCvieSmoZH8mQPCw-tJp2","infoIcon":"_3lmxkxAzqHOImwiCfu24bc","content":"_2C0OTDu-Xx4HTwE6EEQBww","title":"_1rn7MLd2Q_t2mMPEUeT4yr","description":"_bhR2qfmtYAWVbQYLEFo"};